import { render, staticRenderFns } from "./DashboardHerinschrijving.vue?vue&type=template&id=77b6fd02&scoped=true"
import script from "./DashboardHerinschrijving.vue?vue&type=script&lang=js"
export * from "./DashboardHerinschrijving.vue?vue&type=script&lang=js"
import style0 from "./DashboardHerinschrijving.vue?vue&type=style&index=0&id=77b6fd02&prod&scoped=true&lang=css"
import style1 from "./DashboardHerinschrijving.vue?vue&type=style&index=1&id=77b6fd02&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b6fd02",
  null
  
)

export default component.exports